// extracted by mini-css-extract-plugin
export default {"menu-title":"Menu_menu-title__GQtnB"};